import { Adapter as r } from "../../../../../adapter.js";
import { StampProgrammeApplicationRuleModel as t } from "./stampProgrammeApplicationRule.model.js";
class p extends r {
  adapt(e) {
    return new t();
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  p as StampProgrammeApplicationRuleAdapter
};
//# sourceMappingURL=stampProgrammeApplicationRule.adapter.js.map
